// @flow
import type { Device } from '../index';

const protocolFactory = (device: Device) => {
  const ProtocolPrototype = function (device: Device) {
    const chr = String.fromCharCode;

    const weightRegexp = new RegExp(`^${chr(0x01)}${chr(0x02)}(.)${chr(0x20)}((\\d){2}${chr(0x2E)}(\\d){3})${chr(0x6B)}${chr(0x67)}.${chr(0x03)}${chr(0x04)}$`);

    let isWaitingForResponse = false;
    let currentString = '';

    this.prepareWeight = () => {
      if (!isWaitingForResponse) {
        isWaitingForResponse = true;
        device.write(0x05);
      }
    };

    this.setResponse = (buffer: Buffer) => {
      if (buffer.toString() === `${chr(0x06)}`) {
        device.write(0x11);
        currentString = '';
        return;
      }

      const res = buffer.toString();

      if (res.startsWith(`${chr(0x01)}${chr(0x02)}`)) {
        currentString = '';
      }

      currentString += res;

      const matches = weightRegexp.exec(currentString);

      if (!matches) return;

      const error = matches[1];

      if (error !== chr(0x53)) {
        currentString = '';
      }

      isWaitingForResponse = false;
    };

    this.getLastWeight = () => {
      const matches = weightRegexp.exec(currentString);

      if (!matches) return null;

      const error = matches[1];

      if (error !== chr(0x53)) {
        return null;
      }

      const weight = matches[2];
      return +weight;
    };
  };

  return new ProtocolPrototype(device);
};

export default protocolFactory;
